<script setup>
import {useConfigurateurStore} from "../../stores/configurateur";
import {ref} from 'vue';
import Logger from "../../utils/logger";
import ConfiguratorCardImage from './ConfiguratorCardImage.vue';

const store = useConfigurateurStore();
const isCollapsed = ref(false);
const showModal = ref(false);
const selectedVoitureForModal = ref(null);

const logger = new Logger('configurateur')

const handleChangeVoiture = (voiture_id = null) => {
    // Si un ID est passé et que ce n'est pas un Event, on l'utilise, sinon on utilise celui du store
    const id = (voiture_id && typeof voiture_id !== 'object') ? voiture_id : store.voiture_id;
    store.fetchStep('circuit', {
        voiture_id: store.voiture_id,
        circuit_id: store.circuit_id,
    })
}

const selectVoiture = (voiture_id) => {
    logger.log('Carte voiture cliquée pour ID:', voiture_id);
    if (!store.voitureValidForCircuit(voiture_id) && store.first_step == 'circuit') {
        logger.log('La voiture n\'est pas valide pour le circuit');
        return;
    }
    store.voiture_id = voiture_id;
    if (!store.voitureValidForCircuit(voiture_id) && store.voiture) {
        store.circuit_id = store.voiture.circuit_ids ? store.voiture.circuit_ids[0] : null;
    }
    handleChangeVoiture(voiture_id);
}

const toggleCollapse = () => {
    isCollapsed.value = !isCollapsed.value;
}

const showVoitureInfo = (voiture, event) => {
    logger.log('Icône info cliquée pour:', voiture.marque, voiture.designation);
    selectedVoitureForModal.value = voiture;
    showModal.value = true;
}

const closeModal = () => {
    showModal.value = false;
    selectedVoitureForModal.value = null;
}

</script>

<template>
    <section id="step-voiture">
        <div class="card-step-group shadow-sm">
            <div class="step-title d-flex justify-content-between align-items-center">
                <div class="circle" :class="{'active': 1 == store.step, 'completed': store.isCompleted(1)}">
                    {{ store.getStepNumber('voiture') }}
                </div>
                <span class="h5 large fw-bolder mb-2">{{ $t('Choisissez votre voiture') }}</span>
                <button class="btn btn-sm" type="button" @click="toggleCollapse">
                    <i class="bi" :class="isCollapsed ? 'bi-plus-circle' : 'bi-dash-circle'"></i>
                </button>
            </div>
            <div id="collapse-voitures"
                 class="mb-4 pb-1 card-step d-sm-block card card-step"
                 :class="{ 'show': !isCollapsed, 'collapse': isCollapsed }">
                <div class="card-title">
                    <p class="h3 m-0" v-if="store.voiture">{{ store.voiture.title }}</p>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div id="list-voitures" class="col-md-12">
                            <div class="accordion-body px-0 row ">


                                <div class="col-6 col-xl-6 col-xxxl-4 p-2" v-for="voiture in store.voituresFiltered"
                                     :key="voiture.id">
                                    <div
                                        class="card card-config card-voiture-config"
                                        :class="{
                                                'card-selected': store.voiture_id === voiture.id,
                                                'disabled': !store.voitureValidForCircuit(voiture.id)
                                            }"
                                        style="cursor: pointer;">
                                        <div class="form-check form-switch">
                                            <input @click.stop
                                                   @change="handleChangeVoiture"
                                                   v-model="store.voiture_id" :value="voiture.id"
                                                   class="form-check-input" type="radio"
                                                   name="car-product"
                                                   :id="'car-product-' + voiture.id">
                                        </div>

                                        <div @click="selectVoiture(voiture.id)" class="card-clickable-area">
                                            <i class="bi bi-info-circle-fill show-infos"
                                               @click.stop.prevent="showVoitureInfo(voiture)"
                                               title="Voir les détails de la voiture"></i>
                                            <ConfiguratorCardImage
                                                :src="voiture.image"
                                                :alt="`${voiture.marque} ${voiture.designation}`"
                                            />

                                            <div class="card-body">
                                                <div class="card-text">
                                                    <span class="fw-bold">{{ voiture.marque }} {{
                                                            voiture.designation
                                                        }}</span>
                                                </div>
                                                <div class="card-price">
                                                    <div v-if="voiture.price.promo"
                                                         class="badge bg-danger text-white text-center fw-bolder">
                                                        -{{ voiture.price.promo }}
                                                    </div>
                                                    <span class="small fw-normal">{{ $t('À partir de ') }}</span>
                                                    <div
                                                        class="price d-flex flex-row align-items-baseline">

                                                        
                                                                    <span
                                                                        v-if="voiture.price.old_montant_ttc && voiture.price.old_montant_ttc !== voiture.price.montant_ttc"
                                                                        class="old-price fw-normal text-decoration-line-through small fs-xxl-6 me-2">&nbsp;{{
                                                                            voiture.price.old_montant_ttc
                                                                        }}€</span>
                                                        <span
                                                            class="text-info price fw-bolder small fs-xl-6 fs-xxl-5 p-lg-0 p-xl-0">{{
                                                                voiture.price.montant_ttc
                                                            }}€</span>
                                                        <span class="nb fw-normal small">/{{
                                                                voiture.price.nb_tour_min
                                                            }} tours</span>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal pour les informations de la voiture -->
            <div v-if="showModal" class="step-modal-overlay" @click="closeModal">
                <div class="step-modal-content" @click.stop>
                    <div class="step-modal-header">
                        <h3 class="step-modal-title">
                            {{ selectedVoitureForModal?.marque }} {{ selectedVoitureForModal?.designation }}
                        </h3>
                        <button type="button" class="btn-close" @click="closeModal">
                            <i class="bi bi-x-lg"></i>
                        </button>
                    </div>
                    <div class="step-modal-body">
                        <div v-if="selectedVoitureForModal" class="card-voiture-infos">
                            <div class="card-text">
                                <div class="d-flex justify-content-between text-gray-70">
                                    <div class="d-block d-md-flex text-center text-md-start">
                                        <i class="bi bi-speedometer fs-4 me-2"></i>
                                        <div>
                                            <p class="fw-bold small lh-sm mb-0">{{
                                                    selectedVoitureForModal.vitesse_max
                                                }}</p>
                                            <p class="fw-bold small lh-sm mb-0">{{
                                                    selectedVoitureForModal.acceleration
                                                }}/10</p>
                                        </div>
                                    </div>

                                    <div class="d-block d-md-flex text-center text-md-start">
                                        <i class="bi bi-segmented-nav fs-4 me-2"></i>
                                        <div>
                                            <p class="fw-bold small lh-sm mb-0">{{
                                                    selectedVoitureForModal.puissance
                                                }}</p>
                                            <p class="fw-bold small lh-sm mb-0">
                                                {{ selectedVoitureForModal.poids_puissance }}/10</p>
                                        </div>
                                    </div>

                                    <div class="d-block d-md-flex text-center text-md-start">
                                        <svg class='cylindree' style="margin-right:5px;"
                                             xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision"
                                             text-rendering="geometricPrecision" image-rendering="optimizeQuality"
                                             fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 509.77">
                                            <path
                                                d="M244.48 209.89c1.8 18.05-22.84 51.63-33.52 62.51-21.3 21.66-40.94 45.37-73.68 69.79-23.43 17.47-29.49 19.61-57.67 19.22l-1.02-.05c-10.72 0-21.43 2.45-31.23 7.36l-14.85-14.85c-1.98-1.98-5.21-1.98-7.18 0L1.48 377.7c-1.97 1.99-1.97 5.22 0 7.2l14.79 14.78a69.844 69.844 0 0 0-7.46 30.47l-.04 1.04c0 17.86 6.81 35.74 20.44 49.36 13.58 13.58 31.43 20.39 49.35 20.42h.06c10.81 0 21.61-2.5 31.47-7.47l14.78 14.79c1.98 1.97 5.21 1.97 7.19 0l23.84-23.85c1.98-1.97 1.98-5.19 0-7.18l-14.85-14.85c4.91-9.8 7.36-20.51 7.36-31.23 0-29.62 1.48-35.84 20.2-60.62 24.44-32.39 47.49-50.85 68.75-71.76 10.86-10.68 44.46-33.54 62.5-33.53l-55.38-55.38zM355.29.95c70.35 38.85 119.62 87.62 155.76 155.77 1.01 1.87 1.5 3.96 0 5.46l-17.61 17.61L332.22 18.56 349.83.95c1.5-1.5 3.61-1.01 5.46 0zm11.67 144.1c12.77 12.78 12.77 33.49-.01 46.27-12.77 12.77-33.48 12.78-46.26 0-12.78-12.78-12.78-33.5 0-46.27 12.78-12.78 33.49-12.78 46.27 0zm114.96 46.27-10.68 10.67L310.01 40.77l10.68-10.68 161.23 161.23zm-22.21 22.2L357.59 315.65c-1.47 1.46-3.98 1.46-5.46-.01l-24.44-24.45 5.73-5.74c13.43-13.43.19-17.84-13.19-31.23l-62.43-62.43c-13.39-13.38-17.86-26.58-31.24-13.2l-5.74 5.74-24.46-24.45c-1.47-1.48-1.5-3.96 0-5.46L298.48 52.29l161.23 161.23zm-354.15 217.6c0 14.68-11.9 26.59-26.59 26.59-14.68 0-26.58-11.91-26.58-26.59 0-14.69 11.9-26.59 26.58-26.59 14.69 0 26.59 11.9 26.59 26.59z"></path>
                                        </svg>
                                        <div>
                                            <p class="fw-bold small lh-sm mb-0">{{
                                                    selectedVoitureForModal.cyclindree
                                                }}</p>
                                            <p class="fw-bold small lh-sm mb-0">{{
                                                    selectedVoitureForModal.prise_en_main
                                                }}/10</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-text mt-3" v-if="selectedVoitureForModal.description">
                                <p v-safe-html="selectedVoitureForModal.description"></p>
                            </div>
                            <div class="card-text mt-3" v-if="selectedVoitureForModal.avis_parrain	">
                                <p v-safe-html="selectedVoitureForModal.avis_parrain	"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>

</template>
